import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useMakeDefaultCodingBranch = () => {
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const makeDefault = ({ guid, onSuccess }) => {
    setLoading(true);
    axiosClient
      .put(`/Product/Branch/Codding/MakeDefault`, guid, {
        headers: {
          'Content-Type': 'application/json-patch+json',
        },
      })
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`کد به عنوان پیش‌فرض تنظیم شد`, {
            variant: 'success',
          });
          onSuccess?.();
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setLoading(false));
  };
  return { makeDefault, loading };
};

export default useMakeDefaultCodingBranch;
